"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminDebitOrCreditDpayRequestBodyToJSON = exports.AdminDebitOrCreditDpayRequestBodyFromJSONTyped = exports.AdminDebitOrCreditDpayRequestBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function AdminDebitOrCreditDpayRequestBodyFromJSON(json) {
    return AdminDebitOrCreditDpayRequestBodyFromJSONTyped(json, false);
}
exports.AdminDebitOrCreditDpayRequestBodyFromJSON = AdminDebitOrCreditDpayRequestBodyFromJSON;
function AdminDebitOrCreditDpayRequestBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': json['userId'],
        'amountInDpay': !(0, runtime_1.exists)(json, 'amountInDpay') ? undefined : json['amountInDpay'],
        'debit': json['debit'],
        'note': !(0, runtime_1.exists)(json, 'note') ? undefined : json['note'],
        'adminNote': !(0, runtime_1.exists)(json, 'adminNote') ? undefined : json['adminNote'],
    };
}
exports.AdminDebitOrCreditDpayRequestBodyFromJSONTyped = AdminDebitOrCreditDpayRequestBodyFromJSONTyped;
function AdminDebitOrCreditDpayRequestBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
        'amountInDpay': value.amountInDpay,
        'debit': value.debit,
        'note': value.note,
        'adminNote': value.adminNote,
    };
}
exports.AdminDebitOrCreditDpayRequestBodyToJSON = AdminDebitOrCreditDpayRequestBodyToJSON;
